<template>
  <div class="section-parameter" v-if="infos">
    <div class="col-left">
      <h2>{{ $t('settings.ip.title') }}</h2>
    </div>
    <div class="col-right">
      <div class="form-group">
        <el-input type="text" v-model="ip"  @keyup.enter.native="addIP">
          <el-button @click="addIP" slot="append" icon="el-icon-plus"></el-button>
        </el-input>
        <el-tag v-for="(ip, index) in infos.ips" :key="index" closable @close="removeIP(index)">{{ ip }}</el-tag>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      infos: [],
      ip: null
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    })
  },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  methods: {
    ...mapActions('account', ['postIPTrust', 'deleteIPTrust']),
    init () {
      if (this.site) {
        this.infos = Object.assign({}, {
          id: this.site.id,
          ips: this.site.ips
        })
      }
    },
    addIP () {
      if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(this.ip)) {
        this.postIPTrust({site: this.infos, ip: this.ip}).then(() => {
          this.infos.ips.push(this.ip)
          this.ip = null
          this.$notify({title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success'})
        }).catch((e) => {
          this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
        })
      } else {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.settings.invalidIp') })
      }
    },
    removeIP (index) {
      this.deleteIPTrust({ site: this.infos, ip: this.infos.ips[index] }).then(() => {
        this.infos.ips.splice(index, 1)
        this.$notify({ title: 'Success', message: this.$root.$t('notifications.settings.edited'), type: 'success' })
      }).catch((e) => {
        this.$notify.error({ title: 'Error', message: this.$root.$t('notifications.unknown') })
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scopped>
    .el-tag {
        background: white;
        margin:12px 12px 12px 0;
        font-size: 13px;
        font-weight: 600;
        color: #565656;
        border-color: #dedede;

        .el-tag__close  {
            color: #565656;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/settings/settings_ips.vue